import { isInfantile } from 'core/utils/education-levels';

export type ViewerSkinLevel = 'infantil' | 'ESO';
export type ViewerSkinRole = 'student' | 'teacher';

// Temporal hasta reajustar la toolbar infantil de PDF.js (LUC-299); forzar ESO apaga el skin infantil entero del motor, no solo la toolbar.
export const IS_INFANTIL_VIEWER_SKIN_DISABLED = true;

// `isInfantile` no contempla el guid de Inicial (México), y no se toca por ser JS legacy compartido.
const EXTRA_INFANTILE_EDUCATION_LEVELS = new Set(['el-mx-01']);

const PRIMARY_EDUCATION_LEVELS = new Set(['el2', 'el-es-02', 'el-br-02', 'el-mx-02', 'el-ar-02', 'el-us-01']);

const INFANTILE_SKIN_EDUCATION_LEVEL_NAMES = new Set(['infantil', 'primaria']);

function isInfantileSkinEducationLevelGuid(educationLevelGuid?: string | null): boolean {
  if (!educationLevelGuid) return false;

  return isInfantile(educationLevelGuid) || EXTRA_INFANTILE_EDUCATION_LEVELS.has(educationLevelGuid) || PRIMARY_EDUCATION_LEVELS.has(educationLevelGuid);
}

function isInfantileSkinEducationLevelName(educationLevelName?: string | null): boolean {
  const normalizedName = educationLevelName?.trim().toLowerCase() ?? '';

  return INFANTILE_SKIN_EDUCATION_LEVEL_NAMES.has(normalizedName);
}

export function resolveViewerSkinLevel(educationLevelGuid?: string | null, educationLevelName?: string | null): ViewerSkinLevel {
  // Primaria comparte el skin infantil por decisión de producto de la demo (18c3131ada).
  if (isInfantileSkinEducationLevelGuid(educationLevelGuid)) return 'infantil';

  // Hay colegios con niveles de guid propio (p. ej. en QA): el nombre de la etapa es lo único que se mantiene estable.
  if (isInfantileSkinEducationLevelName(educationLevelName)) return 'infantil';

  return 'ESO';
}

export function resolveViewerSkinRole(isStudent: boolean): ViewerSkinRole {
  return isStudent ? 'student' : 'teacher';
}
